"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObjectsMap_1 = require("../helpers/AnimationObjectsMap");
var AnimationFont_1 = require("./AnimationFont");
var FontsMap = (function (_super) {
    tslib_1.__extends(FontsMap, _super);
    function FontsMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FontsMap.prototype.importElement = function (rawData, version) {
        return new AnimationFont_1.AnimationFont(rawData, version);
    };
    FontsMap.prototype.getElementKey = function (element) {
        return element.name;
    };
    return FontsMap;
}(AnimationObjectsMap_1.AnimationObjectsMap));
exports.FontsMap = FontsMap;
//# sourceMappingURL=FontsMap.js.map